<div class="scam-body" [dir]="bodyDir">
    <router-outlet></router-outlet>
</div>
